import React from "react";
import ErrorMessageFramer from "../framerMotion/ErrorMessageFramer";
import useTranslation from "../CustomHooks/useTranslation";
import { errorMessageContents } from "./ErrorMessageContent";

interface ErrorMessageProps {
  errorMessage: string;
  className?: string;
  testId?: string;
  paddingTop?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ errorMessage, className, testId, paddingTop }) => {
  const { translate } = useTranslation(errorMessageContents);

  return (
    <ErrorMessageFramer>
      <p data-testid={testId} className={`text-body2 ${paddingTop || 'pt-1 pb-2' } text-negative wrap-break-word whitespace-normal ${className}`}>
        {translate(errorMessage)}
      </p>
    </ErrorMessageFramer>
  );
};

export default ErrorMessage;
